import { useQuery } from 'react-query';

import { QueryEntity } from '../types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export interface SyncPreviewResponse {
  eligibleForReSync: number;
  skippedNoArtifactId: number;
  sampleFiles: Array<{ id: string; name: string }>;
  fieldMappingConfigured: boolean;
}

interface UseGetRelativitySyncPreviewOptions {
  enabled?: boolean;
}

const useGetRelativitySyncPreview = (
  matterId: string | undefined,
  workspaceId: number | undefined,
  options: UseGetRelativitySyncPreviewOptions = {},
) => {
  const { enabled = true } = options;
  const { fetchConfigGET } = useGetFetchConfig();

  const getSyncPreview = async (): Promise<SyncPreviewResponse> => {
    const url = `${APIBaseChronos}/api/relativity/sync/preview?matterId=${matterId}&workspaceId=${workspaceId}`;
    const response = await fetch(url, fetchConfigGET);

    if (!response.ok) {
      throw new Error(`Failed to fetch sync preview: ${response.status} ${response.statusText}`);
    }

    return response.json();
  };

  return useQuery([QueryEntity.RelativitySyncPreview, { matterId, workspaceId }], getSyncPreview, {
    enabled: enabled && !!matterId && !!workspaceId,
    refetchOnWindowFocus: false,
    retry: false,
  });
};

export default useGetRelativitySyncPreview;
